<template>

  <div>

    <!-- 削除ボタン 中身は下記-->
    <div class="delete-organization">
      <v-layout>
        <v-spacer></v-spacer>
        <v-btn small flat  @click="showDeleteDialog=true" :disabled="!showForm">
          {{$t("account.delete-organization")}}
        </v-btn>
      </v-layout>
    </div>

    <v-form v-if="showForm" ref="editOrganizationForm" v-model="validated"
      class="organization-form">

      <!-- 基本情報 -->
      <div class="ma-3 mb-5">
        <p>{{$t("account.basic-information")}}</p>
        <v-text-field
          :label="editNameLabel"
          v-model="edit.name"
          required
          :rules="[v => !!v || $t('account.vali-org-name')]"
          v-bind:disabled="disabled"
        ></v-text-field>

        <v-text-field
          :label="$t('account.description')"
          v-model="edit.description"
        ></v-text-field>
      </div>

      <!-- 連絡先 -->
      <div class="ma-3">
        <p>{{$t("account.contact")}}</p>
        <v-text-field
          :label="$t('account.incharge')"
          v-model="edit.contact"
        ></v-text-field>

        <v-text-field
          :label="$t('account.tel')"
          :rules="phoneRules"
          v-model="edit.phone"
        ></v-text-field>

        <v-text-field
          :label="$t('account.email')"
          :rules="emailRules"
          v-model="edit.email"
        ></v-text-field>
      </div>

      <div class="btn-box">
        <v-btn
        color="primary"
        class="ma-0"
        :disabled="btnDisable||!validated"
        @click="updateOrganization"
        >
          {{$t("account.edit")}}
        </v-btn>
      </div>

    </v-form>

    <!-- 削除 ダイアログ -->
    <v-dialog v-model="showDeleteDialog" scrollable  max-width="300px">
      <v-card >
        <v-card-title>
          {{$t('account.caution-title')}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          {{$t('account.caution-org-remove-text')}}<br/><br/>
          {{edit.name}}<br/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.prevent="deleteOrganization" color="red">
            {{$t('account.delete')}}
          </v-btn>
          <v-btn small @click.native="showDeleteDialog = false">
            {{$t('account.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import http from '@/utils/http.js'
import validate from '@/utils/validate.js'

export default {
  props: ['selectedOrganizationId'],
  data () {
    return {
      edit: {},
      organizations: [],
      organizationId: null,
      btnDisable: false,
      validated: false,
      showForm: false,
      showDeleteDialog: false,
      editNameLabel: '',

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000,

      // rule
      emailRules: [
        v => validate.emailFormat(v) ||
            this.$t('account.vali-email-format')
      ],
      phoneRules: [
        v => validate.phoneFormat(v) ||
           this.$t('account.vali-phone-format'),
        v => v.length <= 128 || this.$t('account.vali-phone-length')
      ]
    }
  },
  methods: {
    init (organizationId) {
      // ユーザ一覧画面から組織詳細に移った場合、組織一覧では押下されたままなので、反映する
      this.organizationId = organizationId // 一旦格納
      if (this.organizationId === undefined && this.selectedOrganizationId !== null) {
        this.organizationId = this.selectedOrganizationId
      }
      if (Number.isInteger(this.organizationId)) {
        this.getOrganization(this.organizationId)
      }
    },
    getOrganization (organizationId) {
      http.request('get', '/service2/dashboard/api/Organizations/getDetail/' + organizationId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get organization data failed. (' + data.result + ')')
            return
          }
          this.edit = data
          this.disabled = true
          this.editNameLabel = this.$t('account.organization') + ' ' + this.$t('account.fail-master-name')
          if (this.edit.master.depth !== 0) {
            this.disabled = false
            this.editNameLabel = this.$t('account.organization')
          }
          // null値が入っていると、バリデーションが効かない
          for (let k in this.edit) if (this.edit[k] == null) this.edit[k] = ''
          this.showForm = true
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    updateOrganization () {
      this.btnDisable = true
      let params = {
        organizationId: this.edit.id,
        contact: this.edit.contact,
        description: this.edit.description,
        phone: this.edit.phone,
        email: this.edit.email
      }
      if (this.edit.master.depth !== 0) {
        params.name = this.edit.name
      }
      http.request('post', '/service2/dashboard/api/Organizations/updateDetail', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('update organization data failed. (' + data.result + ')')
            this.$emit('child-action', 'error', data.result)
            return
          }
          this.$emit('child-action', 'success', this.$t('account.updated'))
        })
        .catch(error => {
          console.log('error', error)
          if (error.response.status === 403) {
            this.$emit('child-action', 'error', this.$store.getters.message.message)
          } else {
            this.$emit('child-action', 'error', error)
          }
        })
      this.btnDisable = false
    },
    deleteOrganization () {
      console.log('delete:' + this.edit.id)
      http.request('post', '/service2/dashboard/api/Organizations/deleteOrganization', {organizationId: this.edit.id})
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            console.log('delete organization failed. (' + data.result + ')')
            switch (data.result) {
              case -10:
                this.$emit('child-action', 'error', this.$t('account.error-root'))
                break
              case -11:
                this.$emit('child-action', 'error', this.$t('account.error-user'))
                break
              case -12:
                this.$emit('child-action', 'error', this.$t('account.error-customer'))
                break
              case -13:
                this.$emit('child-action', 'error', this.$t('account.error-system'))
                break
              default:
                this.$emit('child-action', 'error', this.$t('account.error-delete'))
            }
            return
          }
          this.$emit('child-action', 'success', this.edit.name + ' has been deleted.')
          this.showForm = false
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
          if (error.response.status === 403) {
            this.$emit('child-action', 'error', this.$store.getters.message.message)
          } else {
            this.$emit('child-action', 'error', error)
          }
        })
      this.showDeleteDialog = false
    }
  },
  computed: {
  },
  mounted () {
    this.init()
  }
}
</script>

<style>

.organization-list{
  height: 100%;
  min-height: 100%;
}

.organization-list-box{
  max-height: 600px;
  overflow-y: scroll;
}

.delete-organization{
  border-bottom: 1px #D0D5E2 solid;
}

.delete-organization p{
  text-align: right;
}

.delete-organization a{
  color: #000!important;
}

.organization-form{
  min-height: 650px;
}

</style>



// WEBPACK FOOTER //
// AccountOrganizationsDetail.vue?2867863f